export enum MajorListSort {
  BEST_FIT = 'bestFit',
  CIP_TITLE = 'cipTitle',
  BEST_FIT_UTAH = 'bestFitUtah',
  CIP_TITLE_UTAH = 'cipTitleUtah',
  NEAREST_UTAH = 'nearestUtah',
}
